module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_privacy_jp.5b4aabb25b39684eb67a59ff15e2312b.png";